import * as THREE from 'three';
import { markForDisposal } from './threeDisposal'

type InstancedSourceMesh = {
  geometry: THREE.BufferGeometry;
  material: THREE.Material | THREE.Material[];
  castShadow: boolean;
  receiveShadow: boolean;
};

export function createInstancedAssetGroup(asset: THREE.Object3D, instanceMatrices: THREE.Matrix4[]): THREE.Group {
  const group = new THREE.Group();
  const sourceMeshes = collectSourceSubMeshes(asset);

  // Iterate each child mesh in the main mesh
  sourceMeshes.forEach((sourceMesh) => {

    // Create total amount of instances
    const instancedMesh = new THREE.InstancedMesh(
      sourceMesh.geometry,
      sourceMesh.material,
      instanceMatrices.length,
    );

    // Instance Settings
    instancedMesh.castShadow = false
    instancedMesh.receiveShadow = false
    instancedMesh.frustumCulled = true;

    // Update each instance to the transform matrix
    instanceMatrices.forEach((matrix, instanceIndex) => {
      instancedMesh.setMatrixAt(instanceIndex, matrix);
    });
    instancedMesh.instanceMatrix.needsUpdate = true;

    // Add to group
    group.add(instancedMesh);
  });

  return group;
}

function collectSourceSubMeshes(asset: THREE.Object3D): InstancedSourceMesh[] {
  const sourceMeshes: InstancedSourceMesh[] = [];
  asset.updateMatrixWorld(true);
  asset.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) {
      return;
    }
    const geometry = child.geometry.clone();
    markForDisposal(geometry)
    geometry.applyMatrix4(child.matrixWorld);
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();
    sourceMeshes.push({
      geometry,
      material: child.material,
      castShadow: false,
      receiveShadow: false,
    });
  });
  return sourceMeshes;
}
